export const GET_COMPANY_REPORT = gql`
    query companyReportLookup($companyNumber: String!) {
        companyReportLookUp(companyNumber: $companyNumber) {
            websiteURL
            companyName
            registrationNumber
            pi_BusinessType
            companyIncorporationDate
            companyAddress
            eircode
            directors {
                firstName
                lastName
                dateOfBirth
                middleNames
                personalAddress {
                    addressLine1
                    addressLine2
                    country
                }
                position
                nationality
                title
            }
            shareholderReport {
                b1DocumentId
                totalShares
                shareSummary
            }
        }
    }
`;
